<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 class="d-inline">Details</h2>
                <router-link class="btn btn-secondary btn-sm ml-5 mr-2" :to="{name:'retailers.edit', params: {id: this.id}}">Edit</router-link> 
                <div class="btn btn-secondary btn-sm" v-on:click="print">Print Page</div>
                <h4 class="mt-3">{{ name }}</h4>
            </div>
            <div class="col-md-6 text-right">
                <h4>Risk Rating: </h4>
                <h4>{{ riskRating }}</h4>
            </div>
        </div>
        <hr>
        <div class="row mt-4">
            <div class="col-lg-5 mb-4">
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>Name: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ name }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>Type: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ retailerType.name }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>Address: </span>
                    </div>
                    <div class="col-md-9">
                        <span v-if="this.postcode">
                            {{ street }},<br>
                            {{  town  }},<br>
                            {{  county  }}<br>
                            {{ postcode }}
                        </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>LPA: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ lpa.name }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>Neighbourhood: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ neighbourhood.name }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>Phone Number: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ phone }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 font-weight-bold">
                        <span>Email: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ email }}</span>
                    </div>
                </div>
                <div class="row mb-3" v-if="this.retailerType.id == 4">
                    <div class="col-md-3 font-weight-bold">
                        <span>Vehicle Description: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ vehicle_description }}</span>
                    </div>
                </div>
                <div class="row mb-3" v-if="this.retailerType.id == 4">
                    <div class="col-md-3 font-weight-bold">
                        <span>VRM: </span>
                    </div>
                    <div class="col-md-9">
                        <span>{{ vrm }}</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mb-4">
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Monday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="mondayOpen || mondayClose">{{ mondayOpen }} - {{ mondayClose }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Tuesday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="tuesdayOpen || tuesdayClose">{{ tuesdayOpen }} - {{ tuesdayClose }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Wednesday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="wednesdayOpen || wednesdayClose">{{ wednesdayOpen }} - {{ wednesdayClose }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Thursday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="thursdayOpen || thursdayClose">{{ thursdayOpen }} - {{ thursdayClose }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Friday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="fridayOpen || fridayClose">{{ fridayOpen }} - {{ fridayClose }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Saturday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="saturdayOpen || saturdayClose">{{ saturdayOpen }} - {{ saturdayClose }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 font-weight-bold">
                        <span>Sunday: </span>
                    </div>
                    <div class="col-md-8">
                        <span v-if="sundayOpen || sundayClose">{{ sundayOpen }} - {{ sundayClose }}</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 mb-4">
                <div class="row mb-3">
                    <div class="col-md-6 font-weight-bold">
                        <span>CCTV Internal: </span>
                    </div>
                    <div class="col-md-1">
                        <span>{{ CCTVInternal == 1 ? 'Yes' : 'No' }}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6 font-weight-bold">
                        <span>CCTV External: </span>
                    </div>
                    <div class="col-md-1">
                        <span>{{ CCTVExternal == 1 ? 'Yes' : 'No' }}</span>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-md-6 font-weight-bold">
                        <span>CCTV Note: </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-11 offset-md-1">
                        <span> {{ CCTVNote }}</span>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-md-6 font-weight-bold">
                        <span>Categories: </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-11 offset-md-1">
                        <ul class="category-list-group list-group list-group-flush">
                            <li class="list-group-item" v-for="category in categories" :key="category.id">
                                {{ category.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <visits-partial :id="id" />
        <hr>
        <history-partial :id="id" />
        <button class="btn btn-link" @click.prevent="back">Back to List</button>
    </div>
</template>

<script>
import VisitsPartial from '../../Partials/VisitsPartial.vue';
import HistoryPartial from '../../Partials/RetailerHistoryPartial.vue';
import RetailersService from "../../../services/RetailersService";
import CurrentUser from '../../../mixins/CurrentUser';

export default {
    data: function () {
        return {
            loading: false,
            lpa: '',
            neighbourhood: '',
            retailerType: '',
            name: '',
            street: '',
            town: '',
            county: '',
            postcode: '',
            lat: '',
            long: '',
            phone: '',
            email: '',
            mondayOpen: '',
            mondayClose: '',
            tuesdayOpen: '',
            tuesdayClose: '',
            wednesdayOpen: '',
            wednesdayClose: '',
            thursdayOpen: '',
            thursdayClose: '',
            fridayOpen: '',
            fridayClose: '',
            saturdayOpen: '',
            saturdayClose: '',
            sundayOpen: '',
            sundayClose: '',
            CCTVInternal: 0,
            CCTVExternal: 0,
            CCTVNote: '',
            categories: [],
            selectedCategories: [],
            riskRating: '',
            lastVisit: null,
            signedUpToWDBC: '',
            checksForSmartwater: '',
            retrievableCCTV: '',
            idCheckingCompliant: '',
            keepsRecords: '',
            signsDisplayed: '',
            propertyCheckingSystem: '',
            unreportedStolenGoods: '',
            vehicle_description: '',
            vrm: '',
            closed_at: null,
            errors: {},
        }
    },

    props: {
        id: {
            default: null,
        },
    },

    mixins: [CurrentUser],

    components: {
        VisitsPartial,
        HistoryPartial
    },

    mounted() {
        this.$store.dispatch('lpas/load');
        this.$store.dispatch('neighbourhoods/load');
        this.$store.dispatch('retailertypes/load');
        this.$store.dispatch('risks/load');
        this.$store.dispatch('productcategories/load');
        this.load();
    },

    watch: {
        id: function () {
            this.load();  
        },
    },

    methods: {

        print() {
            window.print();
        },

        load: function () {
            this.loading = true;

            RetailersService.get(this.id)
                .then( ({data}) => {
                    this.force = data.data.force_id;
                    this.lpa = data.data.lpa;
                    this.neighbourhood = data.data.neighbourhood;
                    this.retailerType = this.$store.state.retailertypes.data.filter(type => type.id === data.data.retailer_type_id)[0];
                    this.name = data.data.retailer_name;
                    this.street = data.data.retailer_street;
                    this.town = data.data.retailer_town;
                    this.county = data.data.retailer_county;
                    this.postcode = data.data.retailer_postcode;
                    this.lat = data.data.lat;
                    this.long = data.data.long;
                    this.phone = data.data.retailer_phone_number;
                    this.email = data.data.retailer_email;
                    this.mondayOpen = data.data.monday_open;
                    this.mondayClose = data.data.monday_close;
                    this.tuesdayOpen = data.data.tuesday_open;
                    this.tuesdayClose = data.data.tuesday_close;
                    this.wednesdayOpen = data.data.wednesday_open;
                    this.wednesdayClose = data.data.wednesday_close;
                    this.thursdayOpen = data.data.thursday_open;
                    this.thursdayClose = data.data.thursday_close;
                    this.fridayOpen = data.data.friday_open;
                    this.fridayClose = data.data.friday_close;
                    this.saturdayOpen = data.data.saturday_open;
                    this.saturdayClose = data.data.saturday_close;
                    this.sundayOpen = data.data.sunday_open;
                    this.sundayClose = data.data.sunday_close;
                    this.CCTVInternal = data.data.cctv_internal;
                    this.CCTVExternal = data.data.cctv_external;
                    this.CCTVNote = data.data.cctv_note;
                    this.selectedCategories = data.data.product_categories.map(category => category.id);
                    this.categories = data.data.product_categories;
                    this.riskRating = data.data.risk_rating;
                    this.vehicle_description = data.data.mobile_vehicle_description;
                    this.vrm = data.data.mobile_vrm;
                    this.loading = false;
                });
        },

        back: function () {
            this.$router.go(-1);
        },
    }

}
</script>